import script from "./percentilesvis.vue?vue&type=script&setup=true&lang=js"
export * from "./percentilesvis.vue?vue&type=script&setup=true&lang=js"

import "./percentilesvis.vue?vue&type=style&index=0&id=747ad918&lang=css"

const __exports__ = script;

export default __exports__